export const TextingSunIcon = (): JSX.Element => (
  <svg width="171" height="152" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="92.5" cy="92.5" rx="50.5" ry="41.5" fill="#FDDA05" />
    <path
      d="M101.137 40.175c-.18-1.081-1.219-1.83-2.32-1.67-1.102.158-1.85 1.163-1.67 2.244l3.99-.575Zm-1.994.287c-1.995.287-1.996.286-1.996.286v-.005l-.001-.005-.002-.009v-.008l.001.019a3.287 3.287 0 0 1-.035.797c-.088.521-.315 1.11-.86 1.594l2.745 2.949c1.38-1.227 1.914-2.71 2.104-3.833a7.15 7.15 0 0 0 .068-1.847 5.417 5.417 0 0 0-.017-.142l-.007-.05a.668.668 0 0 0-.003-.018l-.001-.008-.001-.004v-.002s-.001-.002-1.995.286ZM96.25 43.13c-.36.32-.705.401-1.703.381-.898-.017-2.61-.174-4.277.667l1.9 3.523c.573-.29 1.1-.259 2.361-.234 1.163.023 2.899.003 4.464-1.388l-2.745-2.95Zm-5.98 1.048c-1.668.843-2.713 2.318-3.195 3.798-.47 1.443-.493 3.17.28 4.598l3.566-1.808c-.128-.235-.229-.807.007-1.532.224-.687.671-1.245 1.242-1.533l-1.9-3.523Zm-2.915 8.396c.698 1.29 1.556 1.845 2.133 2.221.424.276.567.372.77.746l3.565-1.808c-.698-1.29-1.556-1.845-2.133-2.22-.424-.277-.567-.373-.77-.747l-3.565 1.808Z"
      fill="#FDDA05"
    />
    <path
      d="M90.563 34.558c-.395-1.014-1.567-1.52-2.617-1.13-1.05.391-1.581 1.53-1.186 2.544l3.803-1.414Zm-1.902.707a344.341 344.341 0 0 1-1.902.705l-.001-.002-.001-.002a7.169 7.169 0 0 1 .36 1.645c.093 1.016-.085 1.798-.522 2.26l2.987 2.646c1.604-1.696 1.712-3.878 1.582-5.287a10.965 10.965 0 0 0-.57-2.59l-.02-.052-.007-.018-.002-.007-.001-.003c-.001-.001-.001-.002-1.903.705Zm-2.066 4.606c-.148.157-.344.275-.765.375-.573.136-.97.139-1.942.29-.822.126-1.854.349-2.868.943-1.044.612-1.928 1.532-2.62 2.842l3.614 1.771c.387-.732.773-1.064 1.09-1.25.347-.203.768-.324 1.392-.42.473-.073 1.514-.173 2.273-.354.911-.216 1.941-.63 2.813-1.551l-2.986-2.646Zm-8.195 4.45c-1.66 3.142-.024 6.15 1.571 8.088 1.665 2.022 3.885 3.645 4.948 4.42l2.46-3.151c-1.084-.79-2.914-2.148-4.223-3.738-1.378-1.673-1.639-2.907-1.142-3.848L78.4 44.321Zm6.52 12.508c1.422 1.037 2.552 1.276 3.433 1.46.696.146 1.142.239 1.866.766l2.459-3.152c-1.423-1.037-2.553-1.275-3.434-1.46-.696-.146-1.142-.238-1.866-.765l-2.459 3.151Z"
      fill="#FDDA05"
    />
    <g filter="url(#a)">
      <ellipse
        cx="67"
        cy="86.5"
        rx="5"
        ry="3.5"
        fill="#FB9378"
        fillOpacity=".38"
      />
    </g>
    <g filter="url(#b)">
      <ellipse
        rx="4.713"
        ry="3.699"
        transform="matrix(.95621 -.29267 .44542 .89532 105.063 82.705)"
        fill="#FB9378"
        fillOpacity=".38"
      />
    </g>
    <circle cx="76" cy="82" r="1" fill="#666" />
    <circle cx="97" cy="81" r="1" fill="#666" />
    <g filter="url(#c)">
      <rect
        x="99.252"
        y="90"
        width="38.514"
        height="23.626"
        rx="4"
        transform="rotate(89.214 99.252 90)"
        fill="#AFDAF7"
      />
      <rect
        x="100.238"
        y="88.986"
        width="40.514"
        height="25.626"
        rx="5"
        transform="rotate(89.214 100.238 88.986)"
        stroke="#82C5F3"
        strokeWidth="2"
      />
    </g>
    <path
      d="M53.914 99.911a2 2 0 0 0-3.087 2.544l3.087-2.544Zm27.724 13.023a2 2 0 0 0-1.022-3.868l1.022 3.868Zm-30.811-10.479c2.557 3.104 5.621 3.529 8.335 3.614 2.79.088 4.927-.102 7.208.935l1.655-3.642c-3.219-1.463-6.492-1.22-8.737-1.291-2.323-.073-3.922-.398-5.374-2.16l-3.087 2.544Zm15.543 4.549c1.215.552 2.304 1.244 3.384 1.995 1.018.708 2.188 1.59 3.268 2.279 2.326 1.482 5.022 2.605 8.616 1.656l-1.022-3.868c-2.08.55-3.598.015-5.444-1.161-1.005-.641-1.91-1.338-3.133-2.189-1.162-.808-2.479-1.656-4.014-2.354l-1.655 3.642ZM124.983 97.926a2 2 0 0 1 3.12 2.503l-3.12-2.503Zm-27.552 13.381a2 2 0 0 1 .972-3.881l-.972 3.881Zm30.672-10.878c-2.517 3.137-5.575 3.602-8.287 3.722-2.789.124-4.928-.038-7.195 1.028l-1.703-3.619c3.2-1.505 6.475-1.305 8.72-1.405 2.321-.103 3.917-.448 5.345-2.23l3.12 2.504Zm-15.482 4.75c-1.208.568-2.289 1.274-3.359 2.039-1.008.722-2.166 1.619-3.238 2.321-2.307 1.513-4.988 2.671-8.593 1.768l.972-3.881c2.086.523 3.598-.032 5.428-1.232.996-.653 1.892-1.362 3.104-2.229 1.151-.823 2.457-1.688 3.983-2.405l1.703 3.619Z"
      fill="#E4C610"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100 19a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h41.222l2.911 5.178L147.202 43H149a2 2 0 0 0 2-2V23a4 4 0 0 0-4-4h-47Z"
      fill="#259BE9"
      fillOpacity=".75"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71 47a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H29.778l-2.911 5.178L23.798 71H22a2 2 0 0 1-2-2V51a4 4 0 0 1 4-4h47Z"
      fill="#999"
      fillOpacity=".79"
    />
    <defs>
      <filter
        id="a"
        x="60"
        y="81"
        width="14"
        height="11"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="b"
        x="98.264"
        y="77.116"
        width="13.6"
        height="11.177"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="c"
        x="63.682"
        y="76.055"
        width="48.045"
        height="62.725"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.991667 0 0 0 0 0.991667 0 0 0 0 0.991667 0 0 0 1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);
